/**
 * Disclaimer and Investor Type Agreement
 * 
 */

(function (window, document, $, undefined) {
	'use strict';

	window.disclaimer = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			if (typeof global_data_layer === 'undefined') {
				return;
			}
			disclaimer.initVars();
			disclaimer.modal();
		},

		/**
		 * Setting and initializing all variables.
		 * @since 1.0.0
		 */
		initVars: function () {
			// Get Main Site Url & Countries Data

			disclaimer.$gatingType = global_data_layer.disclaimer;
			disclaimer.$site = global_data_layer.site.replace('-source', '');
			disclaimer.$cookie = Cookies.get(disclaimer.$gatingType, { path: disclaimer.$site });
			disclaimer.$modal = $('#disclaimerModal');
			disclaimer.$mainUrl = $('#network_url').val();
		},

		/**
			* Disclaimer Module
			*
			* @since 1.0.0
			*/
		modal: function () {
			//console.log(disclaimer.$gatingType);
			var cookieArgs = { expires: 365, path: disclaimer.$site };

			if ('LOCAL' !== localized.gwp_environment) {
				cookieArgs.secure = true;
			}

			if (!disclaimer.$gatingType === null || !disclaimer.$cookie) {
				$('#disclaimerModal').modal('show');
			}

			$(disclaimer.$modal).on('click', '#accept', function (e) {
				e.preventDefault();

				Cookies.set(disclaimer.$gatingType, true, cookieArgs);
				$(disclaimer.$modal).modal('hide');
			});
			/*
			$(disclaimer.$modal).on('click', '.close', function (e) {
				 // console.log("Test");
				// window.location.replace(disclaimer.$mainUrl);
			})
			*/

		},
	};
	disclaimer.init();
})(window, document, jQuery);
